<template>
  <div class="login-container">
    <div class="rehabteach">
      <img src="@/assets/rehabteach.png" alt="智能康复医学教学平台" />
    </div>
    <div class="login-box">
      <h2>智能康复医学教学平台</h2>
      <div>
        <label>账号</label>
        <input v-model="form.username" placeholder="请输入账号"/>
      </div>
      <div>
        <label>密码</label>
        <input v-model="form.password" type="password" placeholder="请输入密码"/>
      </div>
      <button @click="handleLogin">登录</button>
      <div class="tip">
        <span @click="$router.push('/register')">没有账号？去注册</span>
      </div>
    </div>
  </div>
</template>

<script>
import { loginApi, registerApi } from '@/api/user'
// 导入问卷状态接口
import { apiGetSurveyStatus } from '@/api/survey'

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        alert('账号密码不能为空')
        return
      }
      try {
        const res = await loginApi(this.form)
        const token = res.data.token
        const userName = res.data.username
        const userId = res.data.userId

        this.$store.commit('user/SET_TOKEN', token)
        this.$store.commit('user/SET_USER_INFO', {
          userId: userId,
          userName: userName
        })

        const statusRes = await apiGetSurveyStatus()
        console.log("问卷状态statusRes：", statusRes)
        const surveyData = statusRes.data

        this.$store.commit("user/SET_SURVEY_STATUS", surveyData)

        if (!surveyData.preTestFinished) {
          this.$router.push('/survey/pre-test')
        } else {
          this.$router.push('/home')
        }

      } catch (err) {
        console.error('登录失败', err)
        alert('登录失败，请检查账号密码')
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 美化：浅蓝渐变医疗背景 */
  background: linear-gradient(135deg, #e8f4f8 0%, #f0f7fb 100%);
  gap: 60px;
  padding: 0 40px;
}

.login-left {
  width: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-left img {
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
}

.login-box {
  width: 400px;
  padding: 36px 32px;
  background: #ffffff;
  border-radius: 12px;
  /* 柔和阴影，医疗系统常用 */
  box-shadow: 0 8px 24px rgba(70, 130, 180, 0.12);
}

.login-box h2 {
  text-align: center;
  margin-bottom: 32px;
  color: #2c3e50;
  font-weight: 600;
}

.login-box div {
  margin: 16px 0;
}

.login-box label {
  display: block;
  margin-bottom: 6px;
  color: #445668;
  font-size: 15px;
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  border: 1px solid #d0dde8;
  border-radius: 8px;
  font-size: 15px;
  background-color: #fafcfe;
}

input:focus {
  outline: none;
  border-color: #5499c7;
}

button {
  width: 100%;
  margin: 10px 0;
  padding: 12px;
  background: #4088bc;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

button:hover {
  background-color: #3375a4;
}

.tip {
  text-align: center;
  margin-top: 14px;
  color: #4088bc;
  cursor: pointer;
}

/* 小屏幕：图片表单上下堆叠 */
@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
  }
  .login-left {
    width: 300px;
  }
}
</style>